import { Controller } from "stimulus";

export default class extends Controller {
  flashMessage(message) {
    document.getElementById("notice-container").innerHTML =
      '<p class="alert">' + message + "</p>";
    setTimeout(() => $("p.alert").addClass("fade-out"), 5000);
  }
}
